export const ACCENT_COLORS = [
  { value: '', label: 'Default' },
  { value: '#3b82f6', label: 'Blue' },
  { value: '#8b5cf6', label: 'Violet' },
  { value: '#10b981', label: 'Emerald' },
  { value: '#f59e0b', label: 'Amber' },
  { value: '#ef4444', label: 'Red' },
  { value: '#ec4899', label: 'Pink' },
  { value: '#06b6d4', label: 'Cyan' },
  { value: '#f97316', label: 'Orange' },
] as const;

export const DESIGN_SYSTEM_THEMES = [
  { value: '__default__', label: 'Default' },
  { value: 'avilaroffe', label: 'Avila Roffe' },
  { value: 'corporate', label: 'Corporate' },
  { value: 'marvel', label: 'Marvel' },
  { value: 'perplexity', label: 'Perplexity' },
  { value: 'ghibli-studio', label: 'Ghibli Studio' },
  { value: 'clean-slate', label: 'Clean Slate' },
  { value: 'neo-brutalism', label: 'Neo Brutalism' },
  { value: 'spotify', label: 'Spotify' },
  { value: 'marshmallow', label: 'Marshmallow' },
  { value: 'art-deco', label: 'Art Deco' },
  { value: 'claude', label: 'Claude' },
] as const;
